import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import Layout from '../components/layout'
import Nav from '../components/nav'
import SEO from '../components/seo'
import FaqCard from '../components/content/faqCard'
import '../styles/index.scss'

import OptBtn from '../components/button'

// Content components
import Integrations from '../components/content/integrations'
import Stories from '../components/stories'

// channels
import bannerImg from '../images/home/redesign01/banner-home.png'
import u01Img from '../images/home/redesign01/u01.png'
import u02Img from '../images/home/redesign01/u02.png'
import u03Img from '../images/home/redesign01/u03.png'
import u04Img from '../images/home/redesign01/u04.png'
import u05Img from '../images/home/redesign01/u05.png'
import u06Img from '../images/home/redesign01/u06.png'
import mobile from '../images/home/redesign01/mobile.png'

// customers
import customer_aldeas from '../images/home/clients/customer_aldeas.png'
import customer_baristi from '../images/home/clients/customer_baristi.png'
import customer_ccti from '../images/home/clients/customer_ccti.png'
import customer_conoc from '../images/home/clients/customer_conoc.png'
import customer_crucijuegos from '../images/home/clients/customer_crucijuegos.png'
import customer_descuentos from '../images/home/clients/customer_descuentos.png'
import customer_ginza from '../images/home/clients/customer_ginza.png'
import customer_ioimporto from '../images/home/clients/customer_ioimporto.png'
import customer_mcc from '../images/home/clients/customer_mcc.png'
import customer_med from '../images/home/clients/customer_med.png'
import customer_reba from '../images/home/clients/customer_reba.png'
import customer_san_lorenzo from '../images/home/clients/customer_san_lorenzo.png'
import customer_whyline from '../images/home/clients/customer_whyline.png'
import customer_xe_seguridad from '../images/home/clients/customer_xe_seguridad.png'

import { ErrorBoundaryWithLogger } from '../frontend-lib/Log'

function ChatGPT ({ lang }) {
    const text = {
        es: {
            cs_jobTitle_1: 'CEO en Reba',
            cs_title_1:
                'La mejor plataforma para atención automatizada y centralizada en WhatsApp',
            cs_description_1:
                'Encontramos en Optiwe el partner ideal para mejorar significativamente la experiencia de servicio a nuestros clientes. En solo unos pocos meses pudimos automatizar el 40% de los mensajes/preguntas de nuestros clientes y ofrecer atención personalizada con AI 24x7.',
            cs_jobTitle_2: 'Asesora de Campaña',
            cs_title_2: 'El mejor CRM para WhatsApp',
            cs_description_2:
                'En Optiwe encontramos el partner ideal para escalar nuestro servicio al donante a través de nuestro sitio web y WhatsApp. También, gracias a sus herramientas de outbound, podemos comunicarnos con nuevos potenciales donantes en tiempo real y brindarles la mejor experiencia posible. Estamos muy felices de contar con la tecnología de Optiwe para potenciar a nuestros equipos de atención al donante.',
            page_title: 'Optiwe - Atención al Cliente Multiagente y CRM WhatsApp',
            page_description:
                'Optiwe es el mejor CRM WhatsApp multiagente y multicanal para atender clientes en WhatsApp, Instagram, Facebook y tu sitio web.',
            page_lang: 'es',
            h1_strong: 'ChatGPT para Ventas Online',
            h1_normal:
                'que ayuda a tu empresa a atender tus clientes 24x7 en WhatsApp y todos los canales que tus clientes utilizan',
            h1_description_1:
                'Responde conversaciones de Ventas y Atención al Cliente de manera automática en WhatsApp, Instagram, Facebook y tu sitio web.',
            h1_description_2:
                'Optiwe utiliza ChatGPT para automatizar las conversaciones con tus clientes y notificar a tu equipo de ventas y atención al cliente cuando una conversación requiere atención.',
            demo: 'Agendar demo',
            test: 'Probar gratis',
            customers:
                'Sumate a las empresas que ya están potenciando sus procesos ventas y atención al cliente con ChatGPT',
            h2_benefits: 'Beneficios de utilizar Optiwe y ChatGPT en tu negocio',
            h2_benefits_description:
                'Optiwe utiliza Inteligencia Artificial y ChatGPT para ayudarte a vender 24x7 en WhatsApp y los canales que tus clientes utilizan',
            h2_benefits_1:
                'de aumento en la productividad de tu equipo de ventas y atención al usar nuestras herramientas inteligentes para chatear con clientes.',
            h2_benefits_2:
                'de automatización de las conversaciones de ventas y atención al cliente con nuestros chatbots y flujos inteligentes en tan solo 30 días.',
            h2_benefits_3:
                'de aumento en tus ventas en canales digitales al conectar tu sitio web de manera directa con los canales WhatsApp, Instagram y Facebook.',
            h2_productos: '¿Qué puedes hacer con Optiwe y ChatGPT?',
            h2_prod_1_title: 'Vender Online 24x7',
            h2_prod_1_description:
                'Con Optiwe y ChatGPT puedes seguir vendiendo 24x7 en todos los canales que tus clientes utilizan, cómo WhatApp, Instagram y Facebook. Simplemente agregas en Optiwe la información de tus productos y servicios, y ya puedes vender de manera automática con nuestro chatbot potenciado por ChatGPT.',
            h2_prod_1_alt: 'Optiwe y ChatGPT vendiendo online 24x7',
            h2_prod_2_title: 'Aumentar la productividad',
            h2_prod_2_description:
                'Cuando Optiwe no encuentra una respuesta adecuada para tu cliente, puedes derivar automáticamente la conversacióna un vendedor humano para que finalice la venta. Optiwe envía recomendaciones a tus vendedores sobre cómo responder las consultas de tus clientes y aumenta la productividad de tus vendedores.',
            h2_prod_2_alt: 'Optiwe y ChatGPT potenciando a tu equipo de ventas',
            h2_prod_3_title: 'Optiwe y ChatGPT para Delivery',
            h2_prod_3_description:
                'Ahora tus clientes pueden chatear de manera automáticamente con tu negocio para realizar pedidos de comida y coordinar el delivery. Optiwe puede responder preguntas sobre tu menú, informar precios, dar sugerencias en base a los gustos de tus clientes y realizar toda la venta de manera automática.',
            h2_prod_3_alt: 'Optiwe y ChatGPT para delivery de comida',
            h2_prod_4_title: 'Optiwe y ChatGPT para Locales',
            h2_prod_4_description:
                'Si tienen un local que vende productos a consumidores, ahora puedes crear fácilmente tu canal de ventas online con Optiwe y ChatGPT. Simplemente das de alta tus productos en Optiwe, agredas una descripción de los mimos, y nuestro chatbot potenciado por ChatGPT comienza a vender!',
            h2_prod_4_alt: 'Optiwe y ChatGPT para ayudar a locales a vender online',
            h2_prod_5_title: 'Optiwe y ChatGPT para E-Commerce',
            h2_prod_5_description:
                'Si ya tienes un E-Commerce, ahora puedes expandir tus canales de ventas a WhatApp, Facebook, Instagram, SMS y chat web. Optiwe puede levantar la información de tus productos direcamente desde tu sitio web, entrenar el chatbot para responder preguntas sobre tu empresa y comenzar a vender de manera automática.',
            h2_prod_5_alt: 'Optiwe y ChatGPT para ventas en E-Commerce',
            h2_prod_6_title: 'Optiwe y ChatGPT para Inmobiliairas',
            h2_prod_6_description:
                'Ahora puedes responder de manera automática preguntas sobre propiedades en WhatsApp, Instagra, Facebook y tu sitio web. Simplemente agrega la descripción de tus propiedades en Optiwe, y nuestro chatbot potenciado por ChatGPT puede comenzar a recomendar propiedades a clientes y responder todas sus preguntas!',
            h2_prod_6_alt: 'Optiwe y ChatGPT para ventas en Inmobiliairas',
            h2_prod_7_title: 'Optiwe y ChatGPT para Concesionarias',
            h2_prod_7_description:
                'Con Optiwe puedes potenciar las ventas de autos y autopartes directamente en WhatsApp y otros canales digitales. Simplemente agrega tu catalogo de productos a Optiwe y nuestro chatbot potenciado por ChatGPT puede comenzar a responder todas las preguntas de tus clientes!',
            h2_prod_7_alt: 'Optiwe y ChatGPT para ventas en Concesionarias',
            h2_prod_8_title: 'Optiwe y ChatGPT para Turismo',
            h2_prod_8_description:
                'Si tienes una agencia de viajes con diferentes paquetes, ahora puedes cargar la información en Optiwe y nuestro chatbot potenciado por ChatGPT puede ayudar a tus clientes a seleccionar el viaje indicado, responder preguntas del viaje, informar precios y vender de manera automática.',
            h2_prod_8_alt: 'Optiwe y ChatGPT para ventas en Turismo',
            register: 'Regístrate, es gratis!',
            h2_cs:
                'Las empresas que más venden y mejor atienden a sus clientes ya utilizan Optiwe y sus chatbots potenciados por ChatGPT',
            h2_canales: 'Canales de comunicación',
            h2_canales_h3:
                'Comunícate en los canales donde tus clientes te están buscando.',
            h2_canales_description:
                'Utiliza nuestra plataforma de ventas en WhatsApp, Instagram, Facebook, tu sitio web y muchos canales más. Te ayudamos a crear chatbots y reglas de derivación inteligentes a agentes de ventas, para ofrecer la mejor experiencia omnicanal a todos tus clientes! Nuestro CRM utiliza WhatsApp Business API oficial.',
            h2_canales_whatsapp_platform: 'WhatsApp Business Platform',
            h2_canales_whatsapp_business_api: 'WhatsApp Business API oficial',
            h2_integrations: '¿Qué integraciones ofrece Optiwe?',
            talk: '¡Ingresa a la lista de espera ahora!',
            h2_faq: 'Preguntas Frecuentes',
            faq_1: '¿Qué es Optiwe?',
            faq_1_description:
                'Optiwe es un CRM que ayuda a las empresas a aumentar sus ventas en canales digitales como WhatsApp, Instagram, Web Chat, SMS y más. Además, Optiwe desarrolla chatbots basados en inteligencia artificial y ahora está utilizando la API de ChatGPT para mejorar su rendimiento. Optiwe brinda servicios a empresas B2C en diferentes sectores como e-commerce, retail, viajes, bienes raíces, automotriz, delivery, entre otros.',
            faq_2: '¿Qué beneficios ofrece Optiwe?',
            faq_2_description:
                'Optiwe ofrece una gran variedad de beneficios para las empresas que buscan aumentar sus ventas en canales digitales. Con nuestro CRM, las empresas pueden gestionar todas las interacciones con los clientes en diferentes canales en una sola plataforma, lo que ahorra tiempo y aumenta la eficiencia. Además, nuestro chatbot basado en inteligencia artificial puede responder preguntas frecuentes de manera rápida y precisa, reduciendo el tiempo de espera y mejorando la satisfacción del cliente. La integración de la API de ChatGPT permite una experiencia aún más personalizada y mejora la capacidad de respuesta del chatbot.',
            faq_3: '¿Cómo Optiwe utiliza ChatGPT?',
            faq_3_description:
                'Optiwe utiliza la API de ChatGPT para mejorar el rendimiento de su chatbot basado en inteligencia artificial. La API de ChatGPT permite una mejor comprensión del lenguaje natural, lo que significa que el chatbot puede entender mejor las preguntas y necesidades de los clientes. Esto se traduce en respuestas más precisas y rápidas, lo que mejora la satisfacción del cliente y aumenta las tasas de conversión.',
            faq_4: '¿Qué negocios pueden utilizar Optiwe?',
            faq_4_description:
                'Optiwe está diseñado para empresas B2C en diferentes sectores como e-commerce, retail, viajes, bienes raíces, automotriz, delivery, entre otros. Cualquier empresa que busque mejorar su presencia en canales digitales y aumentar sus ventas puede beneficiarse del uso de Optiwe y su chatbot basado en inteligencia artificial. Nuestra solución puede ayudar a las empresas a mejorar su eficiencia, reducir costos y aumentar las ventas en canales digitales, lo que se traduce en un retorno de inversión positivo.'
        },
        en: {
            cs_jobTitle_1: 'CEO at Reba',
            cs_title_1:
                'The best platform for automated and centralized customer service on WhatsApp',
            cs_description_1:
                "We found Optiwe to be the ideal partner to significantly improve our customer service experience. In just a few months, we were able to automate 40% of our customers' messages/questions and offer personalized AI assistance 24x7.",
            cs_jobTitle_2: 'Campaign Advisor',
            cs_title_2: 'The best CRM for WhatsApp',
            cs_description_2:
                'At Optiwe, we found the ideal partner to scale our donor service through our website and WhatsApp. Also, thanks to their outbound tools, we can communicate with new potential donors in real time and provide them with the best possible experience. We are very happy to have Optiwe technology to empower our donor service teams.',
            page_title: 'Optiwe - Multi-Agent Customer Service and WhatsApp CRM',
            page_description:
                'Optiwe is the best multi-agent and multi-channel WhatsApp CRM to serve customers on WhatsApp, Instagram, Facebook and your website.',
            page_lang: 'en',
            h1_strong: 'ChatGPT for Online Sales',
            h1_normal:
                'that helps your company serve your customers 24x7 on WhatsApp and all the channels your customers use',
            h1_description_1:
                'Respond to Sales and Customer Service conversations automatically on WhatsApp, Instagram, Facebook, and your website.',
            h1_description_2:
                'Optiwe uses ChatGPT to automate conversations with your customers and notify your sales and customer service team when a conversation requires attention.',
            demo: 'Schedule a demo',
            test: 'Try for free',
            customers:
                'Join the companies that are already powering up their sales and customer service processes with ChatGPT',
            h2_benefits: 'Benefits of using Optiwe and ChatGPT in your business',
            h2_benefits_description:
                'Optiwe uses Artificial Intelligence and ChatGPT to help you sell 24x7 on WhatsApp and the channels your customers use',
            h2_benefits_1:
                'increase in sales and customer service team productivity by using our intelligent tools to chat with customers.',
            h2_benefits_2:
                'automation of sales and customer service conversations with our chatbots and intelligent flows in just 30 days.',
            h2_benefits_3:
                'increase in digital channel sales by connecting your website directly to WhatsApp, Instagram, and Facebook channels.',
            h2_productos: 'What can you do with Optiwe and ChatGPT?',
            h2_prod_1_title: 'Sell Online 24x7',
            h2_prod_1_description:
                'With Optiwe and ChatGPT, you can continue to sell 24x7 on all the channels your customers use, such as WhatsApp, Instagram, and Facebook. Simply add your product and service information to Optiwe and you can automatically sell with our ChatGPT-powered chatbot.',
            h2_prod_1_alt: 'Optiwe and ChatGPT selling online 24x7',
            h2_prod_2_title: 'Increase productivity',
            h2_prod_2_description:
                "When Optiwe can't find an appropriate answer for your customer, you can automatically redirect the conversation to a human seller to finalize the sale. Optiwe sends recommendations to your sellers on how to respond to your customers' queries and increases your sellers' productivity.",
            h2_prod_2_alt: 'Optiwe and ChatGPT empowering your sales team',
            h2_prod_3_title: 'Optiwe and ChatGPT for Delivery',
            h2_prod_3_description:
                "Now your customers can chat automatically with your business to place food orders and coordinate delivery. Optiwe can answer questions about your menu, provide prices, give suggestions based on your customers' tastes, and make the entire sale automatically.",
            h2_prod_3_alt: 'Optiwe and ChatGPT for food delivery',
            h2_prod_4_title: 'Optiwe and ChatGPT for Local Businesses',
            h2_prod_4_description:
                'If you have a brick-and-mortar store selling products to consumers, you can now easily create your online sales channel with Optiwe and ChatGPT. Simply add your products to Optiwe, add a description of them, and our chatbot powered by ChatGPT will start selling!',
            h2_prod_4_alt: 'Optiwe and ChatGPT helping local businesses sell online',
            h2_prod_5_title: 'Optiwe and ChatGPT for E-Commerce',
            h2_prod_5_description:
                'If you already have an E-Commerce, you can now expand your sales channels to WhatsApp, Facebook, Instagram, SMS, and web chat. Optiwe can scrape information about your products directly from your website, train the chatbot to answer questions about your company, and start selling automatically.',
            h2_prod_5_alt: 'Optiwe and ChatGPT for sales in E-Commerce',
            h2_prod_6_title: 'Optiwe and ChatGPT for Real Estate',
            h2_prod_6_description:
                'Now you can automatically answer questions about properties on WhatsApp, Instagram, Facebook, and your website. Simply add the description of your properties to Optiwe, and our chatbot powered by ChatGPT can start recommending properties to clients and answering all their questions!',
            h2_prod_6_alt: 'Optiwe and ChatGPT for sales in Real Estate',
            h2_prod_7_title: 'Optiwe and ChatGPT for Car Dealerships',
            h2_prod_7_description:
                "With Optiwe, you can boost the sales of cars and car parts directly on WhatsApp and other digital channels. Simply add your product catalog to Optiwe, and our chatbot powered by ChatGPT can start answering all your customers' questions!",
            h2_prod_7_alt: 'Optiwe and ChatGPT for sales in Car Dealerships',
            h2_prod_8_title: 'Optiwe and ChatGPT for Tourism',
            h2_prod_8_description:
                'If you have a travel agency with different packages, now you can upload the information to Optiwe and our ChatGPT-powered chatbot can help your clients select the right trip, answer travel questions, inform about prices, and sell automatically.',
            h2_prod_8_alt: 'Optiwe and ChatGPT for travel sales',
            register: "Sign up, it's free!",
            h2_cs:
                'The companies that sell the most and provide the best customer service already use Optiwe and its ChatGPT-powered chatbots',
            h2_canales: 'Communication Channels',
            h2_canales_h3:
                'Communicate on the channels where your customers are looking for you.',
            h2_canales_description:
                'Use our sales platform on WhatsApp, Instagram, Facebook, your website, and many more channels. We help you create smart chatbots and routing rules to sales agents, to offer the best omnichannel experience to all your customers! Our CRM uses official WhatsApp Business API.',
            h2_canales_whatsapp_platform: 'WhatsApp Business Platform',
            h2_canales_whatsapp_business_api: 'Official WhatsApp Business API',
            h2_integrations: 'What integrations does Optiwe offer?',
            talk: 'Join the waiting list now!',
            h2_faq: 'Frequently Asked Questions',
            faq_1: 'What is Optiwe?',
            faq_1_description:
                'Optiwe is a CRM that helps companies increase their sales on digital channels such as WhatsApp, Instagram, Web Chat, SMS, and more. In addition, Optiwe develops chatbots based on artificial intelligence and is now using the ChatGPT API to improve its performance. Optiwe provides services to B2C companies in different sectors such as e-commerce, retail, travel, real estate, automotive, delivery, among others.',
            faq_2: 'What benefits does Optiwe offer?',
            faq_2_description:
                "Optiwe offers a wide variety of benefits for companies looking to increase their sales on digital channels. With our CRM, companies can manage all customer interactions on different channels in one platform, saving time and increasing efficiency. In addition, our AI-based chatbot can quickly and accurately answer frequently asked questions, reducing wait time and improving customer satisfaction. The integration of the ChatGPT API allows for an even more personalized experience and improves the chatbot's responsiveness.",
            faq_3: 'How does Optiwe use ChatGPT?',
            faq_3_description:
                'Optiwe uses the ChatGPT API to improve the performance of its AI-based chatbot. The ChatGPT API allows for better understanding of natural language, which means the chatbot can better understand customer questions and needs. This results in more precise and faster responses, improving customer satisfaction and increasing conversion rates.',
            faq_4: 'What businesses can use Optiwe?',
            faq_4_description:
                'Optiwe is designed for B2C companies in different sectors such as e-commerce, retail, travel, real estate, automotive, delivery, among others. Any company looking to improve its presence on digital channels and increase sales can benefit from using Optiwe and its AI-based chatbot. Our solution can help companies improve efficiency, reduce costs, and increase sales on digital channels, resulting in a positive return on investment.'
        }
    }

    /*
    ***************
    * SLIDER SETTINGS *
    ***************
    */
    const sliderSettings = {
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 1000,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    autoplay: true,
                    speed: 2000,
                    autoplaySpeed: 2000,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    autoplay: true,
                    speed: 2000,
                    autoplaySpeed: 2000,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true
                }
            }
        ]
    }

    /*
    *********************
    * CUSTOMERS STORIES *
    *********************
    */
    const clientStories = [
        {
            id: '1',
            name: 'Stefano Angeli',
            jobTitle: text[lang].cs_jobTitle_1,
            title: text[lang].cs_title_1,
            description: text[lang].cs_description_1,
            img: customer_reba,
            stars: 5
        },
        {
            id: '2',
            name: 'Noelia Nuñez',
            jobTitle: text[lang].cs_jobTitle_2,
            title: text[lang].cs_title_2,
            description: text[lang].cs_description_2,
            img: customer_aldeas,
            stars: 5
        }
    ]

    function renderSignUpButton (buttonText) {
        if (lang === 'en') {
            return (
                <OptBtn isLink rounded small href="/sign-up/">
                    {text[lang][buttonText]}
                </OptBtn>
            )
        }

        if (lang === 'es') {
            return (
                <OptBtn isLink rounded small href="/es/crear-cuenta/">
                    {text[lang][buttonText]}
                </OptBtn>
            )
        }

        throw new Error('Language not supported')
    }

    return (
        <ErrorBoundaryWithLogger
            serverUrl={process.env.GATSBY_SERVER_URL}
            logName="website"
        >
            <Layout lang={lang}>
                <SEO
                    title={text[lang].page_title}
                    description={text[lang].page_description}
                    lang={text[lang].page_lang}
                    locales={[
                        {
                            hreflang: 'en',
                            href: 'https://optiwe.com/products/chatgpt-for-sales/'
                        },
                        {
                            hreflang: 'es',
                            href: 'https://optiwe.com/es/productos/chatgpt-para-ventas/'
                        },
                        {
                            hreflang: 'x-default',
                            href: 'https://optiwe.com/products/chatgpt-for-sales/'
                        }
                    ]}
                />

                <main className="container-fluid ow-banner">
                    {/*
                    ^*********
                    * HEADER *
                    **********
                    */}
                    <Nav
                        lang={lang}
                        showButtons
                    />

                    {/*
                    ***************
                    * MAIN BANNER *
                    ***************
                    * TODO: If the banner is used in another view, create a <Banner /> component
                    */}
                    <div className="container ow-banner__content">
                        <div className="row">
                            <div className="col-xl-6 col-xxl-6 ow-banner__home-content">
                                <h1 className="ow-banner__title">
                                    <strong>{text[lang].h1_strong}</strong>{' '}
                                    {text[lang].h1_normal}
                                </h1>
                                <p className="ow-banner__text">
                                    {text[lang].h1_description_1}
                                </p>
                                <p className="ow-banner__text">
                                    {text[lang].h1_description_2}
                                </p>
                                <div className="row">
                                    <div className="col-xl-4 mb-3 mb-md-3">
                                        {
                                            renderSignUpButton('demo')
                                        }
                                    </div>
                                    <div className="col-xl-4">
                                        {
                                            renderSignUpButton('test')
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xxl-7 ow-banner__home-image">
                                <img src={bannerImg} alt="optiwe" className="ow-banner__img" />
                            </div>
                        </div>
                    </div>
                </main>

                <section
                    className="container-fluid ow-section ow-section--features"
                    id="features"
                >
                    <div className="container success-stories">
                        <div className="row justify-content-center mb-5">
                            <div className="col-md-10">
                                <h2 className="ow-section__title">
                                    <span className="bold">{text[lang].customers}</span>
                                </h2>
                            </div>
                            <div className="row">
                                <div className="col-md-10"></div>
                            </div>
                        </div>
                        <div className="mb-5">
                            <Slider {...sliderSettings}>
                                <div className="ow-client-wrapper">
                                    <img
                                        src={customer_aldeas}
                                        alt="optiwe"
                                        className="ow-features__img"
                                    />
                                </div>
                                <div className="ow-client-wrapper">
                                    <img
                                        src={customer_baristi}
                                        alt="optiwe"
                                        className="ow-features__img"
                                    />
                                </div>
                                <div className="ow-client-wrapper">
                                    <img
                                        src={customer_reba}
                                        alt="optiwe"
                                        className="ow-features__img"
                                    />
                                </div>
                                <div className="ow-client-wrapper">
                                    <img
                                        src={customer_ccti}
                                        alt="optiwe"
                                        className="ow-features__img"
                                    />
                                </div>
                                <div className="ow-client-wrapper">
                                    <img
                                        src={customer_conoc}
                                        alt="optiwe"
                                        className="ow-features__img"
                                    />
                                </div>
                                <div className="ow-client-wrapper">
                                    <img
                                        src={customer_crucijuegos}
                                        alt="optiwe"
                                        className="ow-features__img"
                                    />
                                </div>
                                <div className="ow-client-wrapper">
                                    <img
                                        src={customer_descuentos}
                                        alt="optiwe"
                                        className="ow-features__img"
                                    />
                                </div>
                                <div className="ow-client-wrapper">
                                    <img
                                        src={customer_ginza}
                                        alt="optiwe"
                                        className="ow-features__img"
                                    />
                                </div>
                                <div className="ow-client-wrapper">
                                    <img
                                        src={customer_ioimporto}
                                        alt="optiwe"
                                        className="ow-features__img"
                                    />
                                </div>
                                <div className="ow-client-wrapper">
                                    <img
                                        src={customer_mcc}
                                        alt="optiwe"
                                        className="ow-features__img"
                                    />
                                </div>
                                <div className="ow-client-wrapper">
                                    <img
                                        src={customer_med}
                                        alt="optiwe"
                                        className="ow-features__img"
                                    />
                                </div>
                                <div className="ow-client-wrapper">
                                    <img
                                        src={customer_san_lorenzo}
                                        alt="optiwe"
                                        className="ow-features__img"
                                    />
                                </div>
                                <div className="ow-client-wrapper">
                                    <img
                                        src={customer_whyline}
                                        alt="optiwe"
                                        className="ow-features__img"
                                    />
                                </div>
                                <div className="ow-client-wrapper">
                                    <img
                                        src={customer_xe_seguridad}
                                        alt="optiwe"
                                        className="ow-features__img"
                                    />
                                </div>
                            </Slider>
                        </div>
                    </div>
                </section>

                {/*
                ****************
                * PORCENTAJES  *
                ****************
                */}
                <section className="benefits-shapes">
                    <svg
                        id="benefits_top_shape"
                        data-name="benefits_top_shape"
                        xmlns="http://www.w3.org/2000/svg"
                        preserveAspectRatio="xMidYMid slice"
                        viewBox="0 0 1920 143.11"
                    >
                        <path
                            className="benefits_top_shape"
                            d="M1920,143.11V38.75C1692.68,104.88,1412.86,127.9,1184.41,89,1083.28,71.8,983,44.3,880.43,45.1,705.88,46.4,536.94,129.6,363.09,114c-77.32-7-151.94-33.2-229.26-39.5C89,70.85,41.09,75.79,0,92.94l.22,50.16Z"
                        />
                        <path
                            className="benefits_top_shape"
                            d="M384,72.49c5.25-.88,10.65-1.89,15.23-4.62s8.23-7.75,7.92-13-4.74-9.86-9.87-11.6-10.8-1-15.93.58c-4,1.19-8.2,3-12.06,1.58-4.14-1.57-6.17-6-8.85-9.53C353,25.85,337.1,22.4,327.17,30c-6,4.54-9.81,15.35-7.06,22.55a25.66,25.66,0,0,0,5.42,8c6.64,6.93,17.09,14.23,27,15.22S374,74.25,384,72.49Z"
                        />
                        <path
                            className="benefits_top_shape"
                            d="M443.55,31.61c3.18-3.33,5.56-8.65,2.74-12.32-2.34-3-7.15-3-10.31-.93-1.72,1.09-4.24,3.37-4.92,5.41-1.2,3.23-1.83,9.65,1.81,11.43C436.71,37.19,440.95,34.38,443.55,31.61Z"
                        />
                    </svg>
                    <div className="container-fluid ow-section--cards" id="benefits">
                        <div className="container">
                            <h2 className="ow-section--cards__title">
                                <span className="bold">{text[lang].h2_benefits}</span>
                            </h2>
                            <p className="ow-section--cards__desc">
                                {text[lang].h2_benefits_description}
                            </p>
                            <div className="row mt-md-5 ow-section--row ow-section--benefits">
                                <div className="col-md-4 ow-section--col mt-3 mt-md-0">
                                    <div className="ow-benefit">
                                        <div className="ow-benefit-number-container">
                                            <svg
                                                className=""
                                                width="200"
                                                height="151"
                                                viewBox="0 0 289 219"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M2.09996 150.4C2.39996 152.1 2.69996 153.7 2.99996 155.3C9.49996 187.5 32.5 212.8 65.7 217.3C109.8 223.2 134.5 192.7 172.7 179.8C197.6 171.4 224.9 171.6 248.9 160.3C270.9 150 287 127.3 288 103C289 78.7 274.2 54.1 251.7 45C233.5 37.6 212.5 40.1 193.9 33.6C177.9 28 165 16.2 149.8 8.80004C106.8 -12.1 48.5 9.70004 22.1 47.1C2.49996 74.7 -3.40004 116.9 2.09996 150.4Z"
                                                    fill="#35209E"
                                                />
                                            </svg>
                                            <p className="ow-benefit__number">+25%</p>
                                        </div>
                                        <p className="ow-benefit__text">
                                            {text[lang].h2_benefits_1}
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-4 ow-section--col mt-3 mt-md-0">
                                    <div className="ow-benefit">
                                        <div className="ow-benefit-number-container">
                                            <svg
                                                width="200"
                                                height="151"
                                                viewBox="0 0 309 205"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M83.7 203C24.1 195.6 -4.70001 141.9 1.59999 85.1C3.59999 67.2 9.2 48.1 20.2 33.6C27.4 24.2 37.7 16.8 49.5 15.4C64.9 13.6 79.3 22 94.1 26.8C131.2 38.9 162.4 23.2 196.4 10.3C218.1 2.09997 242.4 -3.80003 264.3 3.69997C295 14.2 312.5 49.8 308.4 82C304.3 114.2 282.1 141.9 255.1 159.8C228 177.7 196.3 186.9 164.8 194.5C138.2 201 110.8 206.4 83.7 203Z"
                                                    fill="#35209E"
                                                />
                                            </svg>
                                            <p className="ow-benefit__number">+30%</p>
                                        </div>
                                        <p className="ow-benefit__text">
                                            {text[lang].h2_benefits_2}
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-4 ow-section--col mt-3 mt-md-0">
                                    <div className="ow-benefit">
                                        <div className="ow-benefit-number-container">
                                            <svg
                                                width="200"
                                                height="151"
                                                viewBox="0 0 289 219"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M2.09996 150.4C2.39996 152.1 2.69996 153.7 2.99996 155.3C9.49996 187.5 32.5 212.8 65.7 217.3C109.8 223.2 134.5 192.7 172.7 179.8C197.6 171.4 224.9 171.6 248.9 160.3C270.9 150 287 127.3 288 103C289 78.7 274.2 54.1 251.7 45C233.5 37.6 212.5 40.1 193.9 33.6C177.9 28 165 16.2 149.8 8.80004C106.8 -12.1 48.5 9.70004 22.1 47.1C2.49996 74.7 -3.40004 116.9 2.09996 150.4Z"
                                                    fill="#35209E"
                                                />
                                            </svg>
                                            <p className="ow-benefit__number">15%</p>
                                        </div>
                                        <p className="ow-benefit__text">
                                            {text[lang].h2_benefits_3}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <svg
                        id="benefits_bottom_shape"
                        className="benefits_bottom_shape"
                        preserveAspectRatio="xMidYMid slice"
                        viewBox="0 0 1920 143.11"
                        data-name="benefits_bottom_shape"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            className="benefits_bottom_shape"
                            d="M0,0V25.07C100.42,73.33,222.92,85.71,339.3,81.39c156.8-5.8,310.1-35.9,467.5-35.3,150.2.5,300.5,20.5,450.6,13.9,134.5-5.9,267.1-42.9,402.7-27.6,84,9.52,172.75,28.69,259.9,33.2V0Z"
                        />
                    </svg>
                </section>

                {/*
                ************
                * FEATURES *
                ************
                */}
                <section
                    className="container-fluid ow-section ow-section--features"
                    id="features"
                >
                    <div className="container features">
                        <div className="row">
                            <div className="col-md-12 features__content">
                                <h2 className="ow-section__title">
                                    <span className="bold">{text[lang].h2_productos}</span>
                                </h2>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <h3 className="ow-features__title">
                                    {text[lang].h2_prod_1_title}
                                </h3>
                                <p className="ow-features__text">
                                    {text[lang].h2_prod_1_description}
                                </p>
                                <img
                                    className="ow-features__img"
                                    src={u03Img}
                                    alt={text[lang].h2_prod_1_alt}
                                />
                            </div>
                            <div className="col-md-6">
                                <h3 className="ow-features__title">
                                    {text[lang].h2_prod_2_title}
                                </h3>
                                <p className="ow-features__text">
                                    {text[lang].h2_prod_2_description}
                                </p>
                                <img
                                    className="ow-features__img"
                                    src={u04Img}
                                    alt={text[lang].h2_prod_2_alt}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <h3 className="ow-features__title">
                                    {text[lang].h2_prod_3_title}
                                </h3>
                                <p className="ow-features__text">
                                    {text[lang].h2_prod_3_description}
                                </p>
                                <img
                                    className="ow-features__img"
                                    src={u02Img}
                                    alt={text[lang].h2_prod_3_alt}
                                />
                            </div>
                            <div className="col-md-6">
                                <h3 className="ow-features__title">
                                    {text[lang].h2_prod_4_title}
                                </h3>
                                <p className="ow-features__text">
                                    {text[lang].h2_prod_4_description}
                                </p>
                                <img
                                    className="ow-features__img"
                                    src={u01Img}
                                    alt={text[lang].h2_prod_4_alt}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <h3 className="ow-features__title">
                                    {text[lang].h2_prod_5_title}
                                </h3>
                                <p className="ow-features__text">
                                    {text[lang].h2_prod_5_description}
                                </p>
                                <img
                                    className="ow-features__img"
                                    src={u06Img}
                                    alt={text[lang].h2_prod_5_alt}
                                />
                            </div>
                            <div className="col-md-6">
                                <h3 className="ow-features__title">
                                    {text[lang].h2_prod_6_title}
                                </h3>
                                <p className="ow-features__text">
                                    {text[lang].h2_prod_6_description}
                                </p>
                                <img
                                    className="ow-features__img"
                                    src={u05Img}
                                    alt={text[lang].h2_prod_6_alt}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <h3 className="ow-features__title">
                                    {text[lang].h2_prod_7_title}
                                </h3>
                                <p className="ow-features__text">
                                    {text[lang].h2_prod_7_description}
                                </p>
                                <img
                                    className="ow-features__img"
                                    src={u06Img}
                                    alt={text[lang].h2_prod_7_alt}
                                />
                            </div>
                            <div className="col-md-6">
                                <h3 className="ow-features__title">
                                    {text[lang].h2_prod_8_title}
                                </h3>
                                <p className="ow-features__text">
                                    {text[lang].h2_prod_8_description}
                                </p>
                                <img
                                    className="ow-features__img"
                                    src={u05Img}
                                    alt={text[lang].h2_prod_8_alt}
                                />
                            </div>
                        </div>

                        <div className="features__cta mt-5 mb-5">
                            {
                                renderSignUpButton('register')
                            }
                        </div>
                    </div>
                </section>

                {/*
                ************
                * CUSTOMERS *
                ************
                */}
                <section className="clients-shapes">
                    <div className="client_top_shape_wrapper">
                        <svg
                            className="svg_top_shape"
                            id="client_top_shape"
                            data-name="client_top_shape"
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="xMidYMid slice"
                            viewBox="0 0 1920 595"
                        >
                            <path
                                className="clients_top_shape"
                                d="M1920,595V0c-89.19,9.65-163.93,79.77-218.34,153.38-59,79.8-107.78,170.9-189.35,227.3-42.59,29.6-92,47.9-142.07,60.9-54.28,14.1-110.67,22.1-166.55,17.3-88.88-7.6-172.16-47.2-260.44-59.5a433,433,0,0,0-255.13,43c-37.89,19.4-72.78,44.3-110.57,63.9C472.28,561,345,571.38,232.24,534.68,151.25,508.33,76.61,458.85,0,420.92V595Z"
                            />
                        </svg>
                    </div>
                    <div
                        className="container-fluid ow-section ow-section--success-stories"
                        id="success-stories"
                    >
                        <div className="container success-stories">
                            <div className="row justify-content-center mb-5">
                                <div className="col-md-10">
                                    <h2 className="ow-section__title">
                                        <span className="bold">{text[lang].h2_cs}</span>
                                    </h2>
                                </div>
                                <div className="row">
                                    <div className="col-md-10"></div>
                                </div>
                            </div>
                            <Stories stories={clientStories} />
                        </div>
                    </div>
                    <svg
                        id="client_bottom_shape"
                        data-name="client_bottom_shape"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 1920 170"
                    >
                        <path
                            className="client_bottom_shape"
                            d="M0,0V126.36c143.66,40.06,284.7,51.63,445.48,4.58,236.34-69.2,456.88-50.6,696.62-15.6,149.46,21.9,301.72,27,451.88,8.7,111.21-13.59,217-45.86,326-64.76V0Z"
                        />
                    </svg>
                </section>

                {/*
                ************
                * CHANNELS *
                ************
                */}
                <section
                    className="container-fluid ow-section ow-section--channels"
                    id="channels"
                >
                    <div className="container">
                        <div className="row d-flex align-items">
                            <div className="col-md-6 d-flex align-items-center order-1 order-ms-2">
                                <div className="ow-section__content">
                                    <h2 className="ow-section__title">
                                        <span className="bold">{text[lang].h2_canales}</span>
                                    </h2>
                                    <h3 className="ow-section__subtitle">
                                        {text[lang].h2_canales_h3}
                                    </h3>
                                    <p className="ow-section__text">
                                        {text[lang].h2_canales_description}
                                    </p>
                                    <div className="row ow-section--channels__btn">
                                        {
                                            renderSignUpButton('test')
                                        }
                                    </div>
                                    <div className="row ow-section--channels__btn">
                                        <OptBtn
                                            isLink
                                            href="https://business.whatsapp.com/products/business-platform"
                                            rounded
                                            small
                                            className="ws-button"
                                        >
                                            {text[lang].h2_canales_whatsapp_platform}
                                        </OptBtn>
                                    </div>
                                    <div className="row ow-section--channels__btn">
                                        <OptBtn
                                            isLink
                                            href="https://developers.facebook.com/docs/whatsapp/"
                                            rounded
                                            small
                                            className="ws-button"
                                        >
                                            {text[lang].h2_canales_whatsapp_business_api}
                                        </OptBtn>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 order-2 order-md-1">
                                <img src={mobile} alt="Optiwe" className="img-responsive" />
                            </div>
                        </div>
                    </div>
                </section>

                {/*
                ****************
                * INTEGRATIONS *
                ****************
                */}
                <section className="integrations-shapes">
                    <svg
                        id="integrations_top_shape"
                        data-name="integrations_top_shape 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 1920 88"
                    >
                        <path
                            className="integrations_top_shape"
                            d="M1920.5,88V43.27C1753,54.14,1581.09,22.09,1411.3,8.49a2363.54,2363.54,0,0,0-388.3,1c-107.6,9.2-212.8,28.4-321.2,34.8-102.5,6.1-195.5,5.9-297.8-3.9C276.5,28.13,126.69,6.36.5,30.37V88Z"
                        />
                    </svg>
                    <div
                        className="container-fluid ow-section ow-section--clients"
                        id="integrations"
                    >
                        <div className="container">
                            <h2 className="ow-section--clients__title">
                                <span className="bold">{text[lang].h2_integrations}</span>
                            </h2>
                            <Integrations />
                        </div>
                    </div>
                    <svg
                        id="integrations_bottom_shape"
                        data-name="integrations_bottom_shape"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 1920 82.17"
                    >
                        <path
                            className="integrations_bottom_shape"
                            d="M0,0V25.07C100.42,73.33,222.92,85.71,339.3,81.39c156.8-5.8,310.1-35.9,467.5-35.3,150.2.5,300.5,20.5,450.6,13.9,134.5-5.9,267.1-42.9,402.7-27.6,84,9.52,172.75,28.69,259.9,33.2V0Z"
                        />
                    </svg>
                </section>

                <section className="benefits-shapes">
                    <svg
                        id="benefits_top_shape"
                        data-name="benefits_top_shape"
                        xmlns="http://www.w3.org/2000/svg"
                        preserveAspectRatio="xMidYMid slice"
                        viewBox="0 0 1920 143.11"
                    >
                        <path
                            className="benefits_top_shape"
                            d="M1920,143.11V38.75C1692.68,104.88,1412.86,127.9,1184.41,89,1083.28,71.8,983,44.3,880.43,45.1,705.88,46.4,536.94,129.6,363.09,114c-77.32-7-151.94-33.2-229.26-39.5C89,70.85,41.09,75.79,0,92.94l.22,50.16Z"
                        />
                        <path
                            className="benefits_top_shape"
                            d="M384,72.49c5.25-.88,10.65-1.89,15.23-4.62s8.23-7.75,7.92-13-4.74-9.86-9.87-11.6-10.8-1-15.93.58c-4,1.19-8.2,3-12.06,1.58-4.14-1.57-6.17-6-8.85-9.53C353,25.85,337.1,22.4,327.17,30c-6,4.54-9.81,15.35-7.06,22.55a25.66,25.66,0,0,0,5.42,8c6.64,6.93,17.09,14.23,27,15.22S374,74.25,384,72.49Z"
                        />
                        <path
                            className="benefits_top_shape"
                            d="M443.55,31.61c3.18-3.33,5.56-8.65,2.74-12.32-2.34-3-7.15-3-10.31-.93-1.72,1.09-4.24,3.37-4.92,5.41-1.2,3.23-1.83,9.65,1.81,11.43C436.71,37.19,440.95,34.38,443.55,31.61Z"
                        />
                    </svg>
                    <div className="container-fluid ow-section ow-section--faq">
                        <div className="container">
                            <div className="table-pricing-title">
                                <h2 className="ow-section__title">
                                    <span className="bold">{text[lang].h2_faq}</span>
                                </h2>
                            </div>
                            <FaqCard
                                _isOpen={true}
                                title={text[lang].faq_1}
                                text={text[lang].faq_1_description}
                            />
                            <FaqCard
                                _isOpen={true}
                                title={text[lang].faq_2}
                                text={text[lang].faq_2_description}
                            />
                            <FaqCard
                                _isOpen={true}
                                title={text[lang].faq_3}
                                text={text[lang].faq_3_description}
                            />
                            <FaqCard
                                _isOpen={true}
                                title={text[lang].faq_4}
                                text={text[lang].faq_4_description}
                            />
                        </div>
                    </div>
                </section>
            </Layout>
        </ErrorBoundaryWithLogger>
    )
}
export default ChatGPT
